// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';
import Moment from 'react-moment';


function DateLocation(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			margin: '0',
		},
		date: {
			margin: '0 0 0.1em 0',
			lineHeight: context.themeManager
				.value('event-date', 'lineHeight', 'line-height-300'),
			fontWeight: '600',
		},
		location: {
			margin: ' 0 0 0.3em 0',
			lineHeight: context.themeManager
				.value('event-location', 'lineHeight', 'line-height-300'),
			fontWeight: '600',
		},
	};
	return (
		<div className="event__date-venue" style={style.container}>
			<p className="event__date" style={style.date}>
				<Moment locale="de" format="dddd, DD.MM.YYYY HH:mm">{props.date}</Moment>
			</p>
			<p className="event__location" style={style.location}>{props.location}</p>
		</div>
	);
}

export default radium(DateLocation);
